import { render, staticRenderFns } from "./section-list.vue?vue&type=template&id=5b8ac0d6&"
import script from "./section-list.vue?vue&type=script&lang=js&"
export * from "./section-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports